<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div v-if="(dataId != '' && dataId != undefined) || (couponActivityCenterId != '' && couponActivityCenterId != undefined)" slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="searchForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="使用状态：" prop="useStatus">
            <el-select v-model="searchForm.useStatus" placeholder="请选择" class="mt-search-width">
              <el-option
                v-for="item in useStatusArr"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="优惠券名称：" prop="name" v-if="dataId == '' || dataId == undefined">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入优惠券名称搜索"></el-input>
          </el-form-item>
          <el-form-item label="用户搜索：" prop="webSearchStr">
            <el-input class="mt-search-width" v-model="searchForm.webSearchStr" placeholder="请输入用户名称/手机号搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponName"
            label="优惠券名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="nickName"
            label="领取人昵称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userPhone"
            label="手机号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="couponMoney"
            label="优惠券金额">
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="领取时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="receiveType"
            label="获取方式">
            <template slot-scope="scope">
              <span v-if="scope.row.receiveType == 1">手动领取</span>
              <span v-else>系统发放</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="useStatus"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.useStatus == 0">待使用</span>
              <span v-else-if="scope.row.useStatus == 1">已使用</span>
              <span v-else>已过期</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { queryCouponReceiveLogPageList } from '@/api/coupon'
export default {
  name: 'CouponGetRecord',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      dataId: this.$route.query.dataId,
      couponActivityCenterId: this.$route.query.couponActivityCenterId,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      useStatusArr:[{
        value:0,
        label:'待使用'
      },{
        value:1,
        label:'️已使用'
      },{
        value:2,
        label:'️已过期'
      }],
      searchForm: {
        name:'',
        useStatus:'',
        webSearchStr:''
      }
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let couponActivityCenterId = that.couponActivityCenterId == undefined ? '' : that.couponActivityCenterId
      let couponId = that.dataId == undefined ? '' : that.dataId
      let webSearchStr = that.searchForm.webSearchStr
      let useStatus = that.searchForm.useStatus
      let page = that.currentPage
      queryCouponReceiveLogPageList({ couponId: couponId, couponActivityCenterId: couponActivityCenterId, couponName: searchName, webSearchStr: webSearchStr, useStatus: useStatus, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/GetRecord.vue